import React, { useState, useEffect, useRef, useContext } from 'react';
import { WindowSizeContext } from '/src/App';
import AddressSearch from '../../Components/AddressSearch/AddressSearch';
import { useInView } from 'react-intersection-observer';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import HeroSection from './HeroSection/HeroSection';
import HeroSectionAlt1 from './HeroSectionAlt1/HeroSectionAlt1';
import MeetQuollAlt1 from './MeetQuollAlt1/MeetQuollAlt1';
import HowThisWorks from './HowThisWorks/HowThisWorks';
import MeetQuollSection from './MeetQuollSection/MeetQuollSection';
import FinancialThreatNEW from './FinancialThreatNEW/FinancialThreat';
import FinancialThreat from './FinancialThreat/FinancialThreat';
// import OurPromise from './OurPromise/OurPromise';
import PageFooter from '/src/Views/PageFooter/PageFooter';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';


import './style.css';

const HomePage = () => {

  const { deviceType } = useContext(WindowSizeContext);

  // useEffect(() => {
  //   document.title = "Quoll: Your Home's Climate Playbook";
  // }, []);

  const features = [
    {
      icon: "🏠", // We'll replace this with your actual icon
      title: "Quoll Property Intelligence",
      description: "See what we can tell you about each home's future",
      link: "/what-is-quoll"
    },
    {
      icon: "📊", // We'll replace this with your actual icon
      title: "Access + Pricing",
      description: "See how you can access and build on the intelligence",
      link: "/why-free"
    },
    {
      icon: "🌐", // We'll replace this with your actual icon
      title: "Industry Use Cases",
      description: "See different ways our intelligence is being utilized today",
      link: "/resources"
    }
  ];

  return (
    <>
      <HelmetProvider
        pageType="home"
      />
      <div className={`home-page ${deviceType}`}>
        {/* <HeroSection /> */}
        {/* <FinancialThreat /> */}
        <HeroSectionAlt1 />
        <MeetQuollAlt1 />
        <HowThisWorks />
        {/* <FinancialThreatNEW /> */}
        {/* <MeetQuollSection /> */}
        {/* <OurPromise /> */}
        {/* <PageFooter onHomePage={true}/> */}
        {/* <div className="home-page-sections-content">
        <FinancialThreat />
        <MeetQuollSection />
        <OurPromise />
        <PageFooter onHomePage={true}/>
      </div> */}
    </div>
    </>
  );
};

export default HomePage;